// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_345Fe-","icon":"YFXFc-","spinning":"_33-KF-","reverseSpin":"_2TZXg-","hasClick":"_1qmSA-","spin":"_10Ci3-"};